<div class="pointer-events-none fixed bottom-4 right-4 z-1000 flex w-[min(22rem,calc(100vw-2rem))] flex-col gap-3">
  @for (toast of toastService.toasts(); track trackById($index, toast)) {
    <article
      class="pointer-events-auto rounded-xl border p-3 shadow-lg"
      [ngClass]="{
        'border-emerald-500 bg-emerald-50': toast.type === 'success',
        'border-amber-500 bg-amber-50': toast.type === 'warning',
        'border-red-500 bg-red-50': toast.type === 'danger'
      }"
      role="status"
      aria-live="polite"
    >
      <div class="flex items-start gap-3">
        <div
          class="mt-0.5 h-2.5 w-2.5 shrink-0 rounded-full"
          [ngClass]="{
            'bg-emerald-500': toast.type === 'success',
            'bg-amber-500': toast.type === 'warning',
            'bg-red-500': toast.type === 'danger'
          }"
          aria-hidden="true"
        ></div>

        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-slate-900">{{ toast.title }}</p>
          <p class="mt-1 text-sm text-slate-700">{{ toast.message }}</p>
        </div>

        <button
          type="button"
          (click)="removeToast(toast.id)"
          class="rounded-md p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
          aria-label="Dismiss notification"
          title="Dismiss"
        >
          <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>
          </svg>
        </button>
      </div>
    </article>
  }
</div>
